import React, { useState } from 'react';

const Sevenththeme = ({get_data}) => {
    const details = get_data;
    const [cart, setCart] = useState([]);

    const addToCart = (service) => {
        setCart([...cart, service]);
        alert(`Added ${service.service_name} to cart`);
    };
    return (
        <>
            <style>{`
        :root {
            /* Palette: Dynamic Speed */
            --primary: #1a237e;
            /* Navy Blue */
            --primary-dark: #000051;
            --accent: #d32f2f;
            /* Speed Red */
            --accent-hover: #b71c1c;
            --text-dark: #121212;
            --text-gray: #546e7a;
            --bg-light: #eceff1;
            --white: #ffffff;

            --shadow-card: 0 4px 6px rgba(0, 0, 0, 0.1);
            --shadow-hover: 0 15px 30px rgba(0, 0, 0, 0.15);

            --font-head: 'Exo 2', sans-serif;
            --font-body: 'Montserrat', sans-serif;

            --skew: -10deg;
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: var(--font-body);
            color: var(--text-dark);
            background-color: var(--white);
            line-height: 1.6;
            overflow-x: hidden;
        }

        h1,
        h2,
        h3,
        h4,
        h5 {
            font-family: var(--font-head);
            font-weight: 700;
            color: var(--primary);
            text-transform: uppercase;
            line-height: 1.2;
        }

        a {
            text-decoration: none;
            color: inherit;
            transition: 0.3s ease;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
        }

        .section {
            padding: 90px 0;
            position: relative;
        }

        /* Diagonal Section dividers */
        .section-skew {
            position: relative;
            background: var(--bg-light);
            z-index: 1;
        }

        .section-skew::before {
            content: '';
            position: absolute;
            top: -50px;
            left: 0;
            width: 100%;
            height: 100px;
            background: var(--bg-light);
            transform: skewY(2deg);
            z-index: -1;
        }

        /* Buttons */
        .btn {
            display: inline-block;
            padding: 16px 36px;
            background: var(--accent);
            color: var(--white);
            font-family: var(--font-head);
            font-weight: 700;
            text-transform: uppercase;
            border: none;
            cursor: pointer;
            font-size: 0.95rem;
            letter-spacing: 1px;
            transition: 0.3s;
            position: relative;
            overflow: hidden;
            z-index: 1;
            clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);
        }

        .btn::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 0%;
            height: 100%;
            background: var(--primary);
            transition: 0.3s;
            z-index: -1;
        }

        .btn:hover::before {
            width: 100%;
        }

        /* Top Bar */
        .top-bar {
            background: var(--primary-dark);
            color: var(--white);
            padding: 12px 0;
            font-size: 0.85rem;
            font-weight: 500;
        }

        .top-bar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .contact-list {
            display: flex;
            gap: 24px;
        }

        .contact-item {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .contact-item svg {
            width: 16px;
            height: 16px;
            color: var(--accent);
        }

        /* Navbar */
        nav {
            background: var(--white);
            box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
            position: relative;
            z-index: 100;
        }

        nav .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 80px;
        }

        .brand {
            font-family: var(--font-head);
            font-size: 1.8rem;
            font-weight: 800;
            font-style: italic;
            color: var(--primary);
            display: flex;
            align-items: center;
            gap: 5px;
        }

        .brand span {
            color: var(--accent);
        }

        .nav-menu {
            display: flex;
            gap: 30px;
            list-style: none;
            font-weight: 600;
            font-size: 0.9rem;
            text-transform: uppercase;
        }

        .nav-menu a:hover {
            color: var(--accent);
        }

        /* Hero Section */
        .hero {
            height: 700px;
            background: linear-gradient(to right, rgba(26, 35, 126, 0.9) 0%, rgba(26, 35, 126, 0.7) 50%, transparent 100%), url('https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80') no-repeat center center/cover;
            display: flex;
            align-items: center;
            position: relative;
            color: var(--white);
            overflow: hidden;
        }

        .hero::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100px;
            background: var(--white);
            clip-path: polygon(0 100%, 100% 0, 100% 100%);
        }

        .hero-content {
            max-width: 600px;
            padding-right: 50px;
        }

        .hero h1 {
            color: var(--white);
            font-size: 4rem;
            font-style: italic;
            margin-bottom: 20px;
            line-height: 1.1;
        }

        .hero p {
            font-size: 1.1rem;
            margin-bottom: 40px;
            color: rgba(255, 255, 255, 0.85);
        }

        /* Tracking Box */
        .track-box {
            background: var(--white);
            padding: 8px;
            border-radius: 4px;
            display: flex;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
            max-width: 450px;
        }

        .track-box input {
            flex: 1;
            border: none;
            padding: 10px 20px;
            font-family: var(--font-body);
            font-size: 1rem;
            outline: none;
        }

        .track-box button {
            background: var(--accent);
            color: var(--white);
            border: none;
            padding: 0 30px;
            font-weight: 700;
            text-transform: uppercase;
            cursor: pointer;
            transition: 0.3s;
        }

        .track-box button:hover {
            background: var(--primary);
        }

        /* About Section */
        .about-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 60px;
            align-items: center;
        }

        .section-label {
            color: var(--accent);
            font-weight: 700;
            letter-spacing: 2px;
            text-transform: uppercase;
            font-size: 0.85rem;
            display: block;
            margin-bottom: 10px;
        }

        .about-text h2 {
            font-size: 2.5rem;
            margin-bottom: 20px;
        }

        .stat-row {
            display: flex;
            gap: 40px;
            margin-top: 40px;
        }

        .stat-item h3 {
            font-size: 2.5rem;
            color: var(--primary);
            margin-bottom: 5px;
        }

        .stat-item p {
            font-size: 0.85rem;
            font-weight: 600;
            text-transform: uppercase;
            color: var(--text-gray);
        }

        .about-img {
            position: relative;
        }

        .about-img img {
            width: 100%;
            border-radius: 8px;
            box-shadow: var(--shadow-hover);
        }

        .about-img::before {
            content: '';
            position: absolute;
            top: -20px;
            left: -20px;
            width: 100%;
            height: 100%;
            border: 5px solid var(--accent);
            z-index: -1;
            border-radius: 8px;
        }

        /* Services */
        .services-section {
            background-color: var(--bg-light);
            clip-path: polygon(0 5%, 100% 0, 100% 100%, 0 100%);
            padding-bottom: 120px;
        }

        .services-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 24px;
            margin-top: 50px;
        }

        .service-card {
            background: var(--white);
            padding: 30px;
            transition: 0.3s;
            position: relative;
            overflow: hidden;
            border-bottom: 3px solid transparent;
        }

        .service-card:hover {
            transform: translateY(-10px);
            box-shadow: var(--shadow-hover);
            border-bottom-color: var(--accent);
        }

        .service-icon {
            font-size: 2.5rem;
            color: var(--primary);
            margin-bottom: 20px;
            display: inline-block;
        }

        .service-card h3 {
            font-size: 1.25rem;
            margin-bottom: 10px;
        }

        .service-card p {
            font-size: 0.9rem;
            color: var(--text-gray);
            margin-bottom: 20px;
        }

        .service-link {
            font-weight: 700;
            color: var(--accent);
            text-transform: uppercase;
            font-size: 0.8rem;
            display: flex;
            align-items: center;
            gap: 5px;
        }

        .service-link::after {
            content: '→';
            transition: 0.3s;
        }

        .service-card:hover .service-link::after {
            transform: translateX(5px);
        }

        /* Gallery / Fleet */
        .gallery-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 0;
        }

        .gallery-item {
            position: relative;
            height: 300px;
            overflow: hidden;
        }

        .gallery-item img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: 0.5s;
        }

        .gallery-item:hover img {
            transform: scale(1.1);
        }

        .gallery-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 30px;
            background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
            color: var(--white);
            transform: translateY(20px);
            opacity: 0;
            transition: 0.3s;
        }

        .gallery-item:hover .gallery-overlay {
            opacity: 1;
            transform: translateY(0);
        }

        /* Footer */
        footer {
            background: var(--primary-dark);
            color: #cfd8dc;
            padding: 80px 0 30px;
        }

        .footer-grid {
            display: grid;
            grid-template-columns: 2fr 1fr 1fr 1.5fr;
            gap: 40px;
            margin-bottom: 50px;
        }

        .footer-brand {
            font-family: var(--font-head);
            font-size: 2rem;
            color: var(--white);
            font-style: italic;
            font-weight: 800;
            margin-bottom: 20px;
            display: inline-block;
        }

        .footer-brand span {
            color: var(--accent);
        }

        .footer-widget h4 {
            color: var(--white);
            margin-bottom: 25px;
            font-size: 1.1rem;
        }

        .footer-links li {
            list-style: none;
            margin-bottom: 12px;
        }

        .footer-links a:hover {
            color: var(--accent);
        }

        .newsletter input {
            width: 100%;
            padding: 12px;
            border: none;
            margin-bottom: 10px;
            font-family: var(--font-body);
        }

        .footer-bottom {
            border-top: 1px solid rgba(255, 255, 255, 0.1);
            padding-top: 20px;
            text-align: center;
            font-size: 0.85rem;
        }

        /* Responsive */
        @media (max-width: 992px) {
            .hero-content {
                max-width: 100%;
                padding: 0;
                text-align: center;
            }

            .hero {
                justify-content: center;
            }

            .track-box {
                margin: 0 auto;
            }

            .about-grid {
                grid-template-columns: 1fr;
            }

            .stat-row {
                justify-content: flex-start;
            }

            .services-grid {
                grid-template-columns: repeat(2, 1fr);
            }

            .footer-grid {
                grid-template-columns: 1fr 1fr;
            }
        }

        @media (max-width: 768px) {
            .top-bar {
                display: none;
            }

            .nav-menu {
                display: none;
            }

            .hero h1 {
                font-size: 2.5rem;
            }

            .contact-list {
                flex-direction: column;
            }

            .services-grid {
                grid-template-columns: 1fr;
            }

            .gallery-grid {
                grid-template-columns: 1fr;
            }

            .footer-grid {
                grid-template-columns: 1fr;
            }
        }
    `}</style>
            
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
            <link
                href="https://fonts.googleapis.com/css2?family=Exo+2:ital,wght@0,400;0,600;0,700;0,800;1,700&family=Montserrat:wght@400;500;600;700&display=swap"
                rel="stylesheet" />

            {/* Top Bar */}
            <div className="top-bar">
                <div className="container">
                    <div className="contact-list">
                        {details.business_location_name && (
                            <div className="contact-item">
                                <svg fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd"
                                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                        clipRule="evenodd" />
                                </svg>
                                <span>{details.business_location_name}</span>
                            </div>
                        )}
                        {details.email && (
                            <div className="contact-item">
                                <svg fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                                <span>{details.email}</span>
                            </div>
                        )}
                    </div>
                    {details.mobile && (
                        <div className="contact-item">
                            <svg fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                            </svg>
                            <span>Call Us: {details.mobile}</span>
                        </div>
                    )}
                </div>
            </div>

            {/* Nav */}
            <nav>
                <div className="container">
                    <a href="#" className="brand">{details.service_name}</a>
                    <ul className="nav-menu">
                        <li><a href="#">Home</a></li>
                        <li><a href="#about">About</a></li>
                        <li><a href="#services">Services</a></li>
                        <li><a href="#products">Products</a></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>
                </div>
            </nav>

            {/* Hero */}
            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <h1>Moving Your World Forward, Faster.</h1>
                        <p>Global supply chain solutions built on speed, reliability, and precision. We deliver your promises on
                            time, every time.</p>
                        <div className="track-box" id="track">
                            <input type="text" placeholder="Enter Tracking Number or Booking ID" />
                            <button>Track Now</button>
                        </div>
                    </div>
                </div>
            </section>

            {/* About */}
            <section className="section" id="about">
                <div className="container">
                    <div className="about-grid">
                        <div className="about-text">
                            <span className="section-label">Why Choose Us</span>
                            <h2>Connecting Borders With Seamless Logistics</h2>
                            <p>At Velocity Logistics, we understand that time is money. Our integrated network of air, sea, and
                                road transport ensures your cargo reaches its destination safely and efficiently.</p>
                            <p style={{marginTop: '15px'}}>With over 20 years of experience, we have mastered the art of complex
                                supply chain management, offering tailored solutions for businesses of all sizes.</p>

                            <div className="stat-row">
                                <div className="stat-item">
                                    <h3>150+</h3>
                                    <p>Countries</p>
                                </div>
                                <div className="stat-item">
                                    <h3>2.5M</h3>
                                    <p>Parcels Delivered</p>
                                </div>
                                <div className="stat-item">
                                    <h3>99%</h3>
                                    <p>On-Time Rate</p>
                                </div>
                            </div>

                            <button className="btn" style={{marginTop: '30px'}}>More About Us</button>
                        </div>
                        <div className="about-img">
                            <img src="https://images.unsplash.com/photo-1580674684081-7617fbf3d745?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                                alt="Logistics Center" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Services */}
            <section className="section services-section" id="services">
                <div className="container">
                    <div style={{textAlign: 'center', maxWidth: '700px', margin: '0 auto'}}>
                        <span className="section-label">Our Expertise</span>
                        <h2>Comprehensive Solutions</h2>
                        <p style={{color: 'var(--text-gray)'}}>Tailored services designed to meet your specific needs efficiently and reliably.</p>
                    </div>

                    <div className="services-grid">
                        {details.categories && details.categories.map((service, index) => (
                            <div className="service-card" key={index}>
                                {service.icon ? (
                                    <img src={service.icon.startsWith('http') ? service.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${service.icon}`} alt={service.name} style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '50%', marginBottom: '20px' }} />
                                ) : (
                                    <div className="service-icon">{(service.name || 'SV').slice(0, 2).toUpperCase()}</div>
                                )}
                                <h3>{service.name}</h3>
                                <p>{service.description || 'Service description not available.'}</p>
                                <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
                                    <a href={`tel:${details.mobile}`} className="btn" style={{padding: '8px 16px', fontSize: '0.8rem', background: 'transparent', color: 'var(--text-dark)', border: '1px solid var(--text-dark)'}}>Call</a>
                                    <a href="#contact" className="btn" style={{padding: '8px 16px', fontSize: '0.8rem', background: 'transparent', color: 'var(--primary)', border: '1px solid var(--primary)'}}>Enquiry</a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Products */}
            <section className="section" id="products" style={{background: '#fff'}}>
                <div className="container">
                    <div style={{textAlign: 'center', maxWidth: '700px', margin: '0 auto'}}>
                        <span className="section-label">Our Offering</span>
                        <h2>Premium Products</h2>
                    </div>

                    <div className="services-grid">
                        {details.product_services && details.product_services.map((service, index) => (
                            <div className="service-card" key={index} style={{border: '1px solid #eee'}}>
                                {service.featured_image ? (
                                    <img src={service.featured_image.startsWith('http') ? service.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${service.featured_image}`} alt={service.service_name} style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '4px', marginBottom: '20px' }} />
                                ) : (
                                    <div className="service-icon">{(service.service_name || 'PR').slice(0, 2).toUpperCase()}</div>
                                )}
                                <h3>{service.service_name}</h3>
                                <p>{service.description || 'Product description not available.'}</p>
                                <div style={{marginTop: 'auto'}}>
                                    {service.price && <p style={{ fontWeight: '700', fontSize: '1.2rem', color: 'var(--accent)', marginBottom: '15px' }}>₹{service.price}</p>}
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                                        <button 
                                            onClick={() => addToCart(service)}
                                            className="btn"
                                            style={{width: '100%', padding: '10px', fontSize: '0.8rem', textAlign: 'center'}}
                                        >
                                            Order
                                        </button>
                                        <a href={`tel:${details.mobile}`} className="btn" style={{width: '100%', padding: '10px', fontSize: '0.8rem', background: 'transparent', color: 'var(--text-dark)', border: '1px solid var(--text-dark)', textAlign: 'center'}}>Call</a>
                                    </div>
                                    <a href="#contact" className="btn" style={{width: '100%', marginTop: '10px', padding: '10px', fontSize: '0.8rem', background: 'transparent', color: 'var(--primary)', border: '1px solid var(--primary)', textAlign: 'center', display: 'block'}}>Enquiry</a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* Testimonials */}
            <section className="section section-skew" id="reviews" style={{background: '#fff', paddingBottom: '150px'}}>
                <div className="container">
                    <div style={{textAlign: 'center', marginBottom: '60px'}}>
                        <span className="section-label">Client Feedback</span>
                        <h2>Trusted Partners</h2>
                    </div>

                    {details.review_ratings && details.review_ratings.length > 0 ? (
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '40px'}}>
                            {details.review_ratings.map((review, index) => (
                                <div key={index}
                                    style={{background: 'var(--bg-light)', padding: '40px', display: 'flex', gap: '20px', alignItems: 'flex-start', borderLeft: '5px solid var(--accent)'}}>
                                     <div>
                                        {review.rating && (
                                            <div style={{color: '#ffb400', fontSize: '1.2rem', marginBottom: '15px'}}>
                                                {'★'.repeat(Math.round(review.rating)) + '☆'.repeat(5 - Math.round(review.rating))}
                                            </div>
                                        )}
                                        <p style={{fontSize: '1.1rem', color: 'var(--text-gray)', marginBottom: '20px', fontStyle: 'italic'}}>
                                            "{review.review || 'No check detail provided.'}"</p>
                                        <h4 style={{color: 'var(--primary)'}}>{review.user_name || 'Valued Customer'}</h4>
                                        <span style={{fontSize: '0.9rem', color: '#78909c', fontWeight: '600'}}>Verified Client</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{textAlign: 'center', padding: '40px', color: 'var(--text-gray)', fontStyle: 'italic'}}>
                            <p>No reviews yet.</p>
                        </div>
                    )}
                </div>
            </section>


            {/* Footer */}
            <footer id="contact">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-widget">
                            <a href="#" className="footer-brand">{details.service_name}</a>
                            <p>We provide guaranteed quality workmanship for all your needs.</p>
                        </div>
                        <div className="footer-widget" style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                            <h4>Connect</h4>
                            {details.instagram && <a href={details.instagram} style={{color: '#aaa', textDecoration: 'none'}}>Instagram</a>}
                            {details.facebook && <a href={details.facebook} style={{color: '#aaa', textDecoration: 'none'}}>Facebook</a>}
                            {details.youtube && <a href={details.youtube} style={{color: '#aaa', textDecoration: 'none'}}>Youtube</a>}
                            {details.twitter && <a href={details.twitter} style={{color: '#aaa', textDecoration: 'none'}}>Twitter</a>}
                        </div>
                        <div className="footer-widget">
                            <h4>Services</h4>
                            <ul className="footer-links">
                                <li><a href="#services">All Services</a></li>
                                <li><a href="#products">Products</a></li>
                            </ul>
                        </div>
                        <div className="footer-widget">
                            <h4>Contact Info</h4>
                            <p>{details.business_location_name}</p>
                            <p>Email: {details.email}</p>
                            <p>Phone: {details.mobile}</p>
                        </div>
                    </div>
                    <div className="footer-bottom">
                         &copy; {new Date().getFullYear()} {details.service_name || 'Partner Store'}. All Rights Reserved.
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Sevenththeme
